import { Pipe, type PipeTransform } from '@angular/core';
import { TeleexpertiseProvider } from '@shared/models/enums/teleexpertise-provider.enum';

@Pipe({
  name: 'teleexpertiseProvider',
  pure: true,
  standalone: true,
})
export class TeleexpertiseProviderPipe implements PipeTransform {
  transform(providerName: TeleexpertiseProvider): string {
    switch (providerName) {
      case TeleexpertiseProvider.ROFIM:
        return 'Rofim';
      case TeleexpertiseProvider.OMNIDOC:
        return 'Omnidoc';
      default:
        return providerName;
    }
  }
}
